import React, {Component} from 'react'
import './css/App.css'
import AppBar from 'material-ui/AppBar';
import {injectIntl} from 'react-intl';

import {List, ListItem} from 'material-ui/List'
import CheckIcon from 'material-ui/svg-icons/navigation/check'
import CloseIcon from 'material-ui/svg-icons/navigation/close'
import LoginDialog from './LoginDialog'
import TextField from 'material-ui/TextField';
import LinearProgress from 'material-ui/LinearProgress';
import AgreementView from './AgreementView'
import BackToApp from './BackToApp'

import {Container} from 'flux/utils'
import AgrStore from './data/AgrStore'
import AgrActions from './data/AgrActions'

import deeperWhite from './img/deeper_white.png'

class App extends Component {

  static getStores() {
    return [AgrStore];
  }

  static calculateState(prevState) {
    var state = AgrStore.getState().toObject()

    var result = {
      agreements: state.agreements,
      activeAgreement: state.activeAgreement
    }

    return result
  }

  //shouldComponentUpdate = (nextProps, nextState) => { Hack return true }

  componentDidMount = () => {
    AgrActions.checkHash()
  }

  getAgreementError = (agr) => {
    var errorMessage = null
    if (agr.status !== 'agree') {
      if (agr.status === 'blank') {
        errorMessage = this.props.intl.formatMessage({id: "agreements.error.blank"})
      } else if (agr.status === 'reject' && (agr.mandatory === 'true' || agr.mandatory === true)) {
        errorMessage = this.props.intl.formatMessage(
          {id: "agreements.error.mandatory"}
        )
      }
    }

    return errorMessage
  }

  getAgreementListItem = (agr) => {
    var statusIcon = null
    if (agr.status === 'agree') {
      statusIcon = <CheckIcon color="#0ABEB8" style={{
          marginTop: '26px'
        }}/>
    } else if (agr.status === 'reject') {
      statusIcon = <CloseIcon color="#FF4B4A" style={{
          marginTop: '26px'
        }}/>
    }

    return <ListItem
      key={agr.code}
      onClick={() => {
        AgrActions.selectAgreement(agr)
      }}
      rightIcon={statusIcon}>
      <TextField
        style={{
          cursor: "pointer"
        }}
        id={"tf_" + agr.code}
        fullWidth={true}
        value={agr.title}
        readOnly="readonly"
        errorText={this.getAgreementError(agr)}></TextField>
    </ListItem>
  }

  getAgreementsList = () => {
    return this.state.agreements.map((agr, i) => {
      return this.getAgreementListItem(agr)
    })
  }

  render() {
    var agreementList = <LinearProgress/>
    if (this.state.agreements.length !== 0) {
      agreementList = this.getAgreementsList()
    }

    var content = null
    if (this.state.activeAgreement) {
      content = <AgreementView/>
    } else {
      content = <List>
        <ListItem disabled={true}>
          <h1>{this.props.intl.formatMessage({id: "agreements.title"})}</h1>
        </ListItem>
        {agreementList}
      </List>
    }

    return <div>
      <AppBar
        style={{
          backgroundColor: '#0D1730',
          paddingRight: '0px'
        }}
        title={<img alt = "logo" style = {{verticalAlign: 'middle'}}src = {
          deeperWhite
        } />}
        iconStyleRight={{
          marginRight: '0px',
          marginTop: '0px'
        }}
        iconElementRight={<BackToApp/>}
        iconElementLeft={<div />}></AppBar>
      <div className="App">
        <LoginDialog/> {content}
      </div>
    </div>
  }
}
export default injectIntl(Container.create(App))


// WEBPACK FOOTER //
// ./src/App.js